import { Button } from "components/DesignSystem/Button/Button";
import { Cross } from "components/icons/Cross";
import { DividerLine } from "components/icons/DividerLine";
import { SelectedFloatingControl } from "components/SelectedFloatingControl/SelectedFloatingControl";
import { Task1120BulkAction } from "components/TaskTracker/Task1120BulkAction";

type TableSelectionControlsProps = {
  selectedTaskIds: string[];
  resetSelection: () => void;
  selectedRowsServiceTeam: string[];
};

export const Task1120BulkActionsFloat = ({
  selectedTaskIds,
  resetSelection,
  selectedRowsServiceTeam,
}: TableSelectionControlsProps) => {
  return (
    <SelectedFloatingControl>
      {selectedTaskIds.length > 0 && (
        <>
          <span className="t-whitespace-nowrap t-text-subtext t-text-text-60">
            {selectedTaskIds.length} selected
          </span>
          <span className="t-text-neutral-10 t-h-full">
            <DividerLine />
          </span>
          <Task1120BulkAction
            selectedRows={selectedTaskIds}
            resetSelection={resetSelection}
            selectedRowsServiceTeam={selectedRowsServiceTeam}
          />
          <Button
            customType="ghost_icon"
            size="xsmall"
            onClick={resetSelection}
          >
            <Cross />
          </Button>
        </>
      )}
    </SelectedFloatingControl>
  );
};
